import React from 'react';
import '../styles/NosotrosDropdown.css';

const NosotrosDropdown = ({ visible, activeTab, onTabClick }) => {
  const handleClick = (e, tab) => {
    e.preventDefault();
    onTabClick(tab);
  };

  return (
    <div className={`nosotros-dropdown ${visible ? 'visible' : ''}`}>
      <div className="dropdown-content-nosotros">
        <button
          className={`dropdown-tab-nosotros ${activeTab === 'quienes' ? 'active' : ''}`}
          onClick={e => handleClick(e, 'quienes')}
        >
          Quiénes somos
        </button>
        <button
          className={`dropdown-tab-nosotros ${activeTab === 'vision' ? 'active' : ''}`}
          onClick={e => handleClick(e, 'vision')}
        >
          Misión/Visión
        </button>
      </div>
    </div>
  );
};

export default NosotrosDropdown;
